module.exports = __webpack_public_path__ + "img/record-stop.32ec461c.png";